<template>
  <div class="mt-6">


    <div class="d-flex flex-column ga-2" v-if="$store.state.loading">
      <v-skeleton-loader class="gradient" type="list-item" height="36"></v-skeleton-loader>
      <v-skeleton-loader class="gradient" type="list-item" height="36"></v-skeleton-loader>
      <v-skeleton-loader class="gradient" type="list-item" height="36"></v-skeleton-loader>
    </div>

    <div class="d-flex flex-column ga-2" v-else>
      <div class="text-h6 text-center">Résultats Féminins</div>
      <v-btn @click="onSelectEpreuve('raid', 'f')" color="grey-lighten-2"
        :class="[$store.state.current_epreuve == 'raid' && $store.state.current_sexe == 'f' ? 'gradient text-white' : '']"
        block>Le raid</v-btn>
      <v-btn @click="onSelectEpreuve('kayak', 'f')" color="grey-lighten-2"
        :class="[$store.state.current_epreuve == 'kayak' && $store.state.current_sexe == 'f' ? 'gradient text-white' : '']"
        block>Le kayak</v-btn>
      <v-btn @click="onSelectEpreuve('trail', 'f')" color="grey-lighten-2"
        :class="[$store.state.current_epreuve == 'trail' && $store.state.current_sexe == 'f' ? 'gradient text-white' : '']"
        block>Le trail</v-btn>
      <v-btn @click="onSelectEpreuve('penalite', 'f')" color="grey-lighten-2"
        :class="[$store.state.current_epreuve == 'penalite' && $store.state.current_sexe == 'f' ? 'gradient text-white' : '']"
        block>Le tir à l'arc</v-btn>
      <v-divider class="my-2"></v-divider>
      <div class="text-h6 text-center">Résultats mixtes</div>
      <v-btn @click="onSelectEpreuve('raid', 'x')" color="grey-lighten-2"
        :class="[$store.state.current_epreuve == 'raid' && $store.state.current_sexe == 'x' ? 'gradient text-white' : '']"
        block>Le raid</v-btn>
      <v-btn @click="onSelectEpreuve('kayak', 'x')" color="grey-lighten-2"
        :class="[$store.state.current_epreuve == 'kayak' && $store.state.current_sexe == 'x' ? 'gradient text-white' : '']"
        block>Le kayak</v-btn>
      <v-btn @click="onSelectEpreuve('trail', 'x')" color="grey-lighten-2"
        :class="[$store.state.current_epreuve == 'trail' && $store.state.current_sexe == 'x' ? 'gradient text-white' : '']"
        block>Le trail</v-btn>
      <v-btn @click="onSelectEpreuve('penalite', 'x')" color="grey-lighten-2"
        :class="[$store.state.current_epreuve == 'penalite' && $store.state.current_sexe == 'x' ? 'gradient text-white' : '']"
        block>Le tir à l'arc</v-btn>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    onSelectEpreuve(epreuve, sexe) {
      this.$store.commit("setCurrentEpreuve", epreuve);
      this.$store.commit("setSexe", sexe);

    },
  },
};
</script>

<style lang="scss" scoped></style>